import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerData = {
    support: {
      title: 'Support',
      links: [
        { name: 'Help Center', url: '#' },
        { name: 'Safety Information', url: '#' },
        { name: 'Cancellation Options', url: '#' },
        { name: 'Anti-discrimination', url: '#' },
        { name: 'Disability Support', url: '#' }
      ]
    },
    experts: {
      title: 'Experts',
      links: [
        { name: 'Become an Expert', url: '#' },
        { name: 'Expert Resources', url: '#' },
        { name: 'Community Forum', url: '#' },
        { name: 'Expert Standards', url: '#' },
        { name: 'Expert Success Stories', url: '#' }
      ]
    },
    learning: {
      title: 'Learning',
      links: [
        { name: 'How It Works', url: '#' },
        { name: 'Online Sessions', url: '#' },
        { name: 'Group Workshops', url: '#' },
        { name: 'Gift Cards', url: '#' },
        { name: 'Student Discounts', url: '#' }
      ]
    },
    company: {
      title: 'Company',
      links: [
        { name: 'About Us', url: '#' },
        { name: 'Careers', url: '#' },
        { name: 'Press', url: '#' },
        { name: 'Investors', url: '#' },
        { name: 'Blog', url: '#' }
      ]
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Footer Columns */}
        <div className="footer-columns">
          {Object.values(footerData).map((section) => (
            <div key={section.title} className="footer-column">
              <h3>{section.title}</h3>
              <ul>
                {section.links.map((link) => (
                  <li key={link.name}>
                    <a href={link.url}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <p>© {currentYear} ExpertPlatform, Inc.</p>
            <span className="dot">·</span>
            <a href="#">Privacy</a>
            <span className="dot">·</span>
            <a href="#">Terms</a>
            <span className="dot">·</span>
            <a href="#">Sitemap</a>
          </div>
          
          <div className="footer-bottom-right">
            <div className="language-selector">
              <button className="language-btn">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667Z" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M1.33333 8H14.6667M8 1.33333C9.66971 3.21885 10.6154 5.57046 10.6667 8C10.6154 10.4295 9.66971 12.7811 8 14.6667C6.33029 12.7811 5.38456 10.4295 5.33333 8C5.38456 5.57046 6.33029 3.21885 8 1.33333Z" stroke="currentColor" strokeWidth="1.5"/>
                </svg>
                <span>English (CA)</span>
              </button>
            </div>
            <div className="social-links">
              <a href="#" aria-label="Facebook">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M18.896 0H1.104C.494 0 0 .494 0 1.104v17.792C0 19.506.494 20 1.104 20h9.58v-7.745H8.076V9.237h2.606V7.01c0-2.583 1.578-3.99 3.883-3.99 1.104 0 2.052.082 2.329.119v2.7h-1.598c-1.254 0-1.496.597-1.496 1.47v1.928h2.989l-.39 3.018h-2.6V20h5.098c.608 0 1.102-.494 1.102-1.104V1.104C20 .494 19.506 0 18.896 0z"/>
                </svg>
              </a>
              <a href="#" aria-label="Twitter">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M20 3.894c-.74.326-1.53.547-2.36.646.85-.507 1.5-1.31 1.81-2.27-.79.47-1.67.81-2.61.99-.75-.8-1.82-1.3-3-1.3-2.27 0-4.1 1.84-4.1 4.11 0 .32.04.63.11.93-3.41-.17-6.43-1.8-8.46-4.29-.35.61-.55 1.31-.55 2.06 0 1.43.73 2.69 1.84 3.43-.68-.02-1.31-.21-1.87-.52v.05c0 1.99 1.42 3.65 3.29 4.03-.34.09-.71.14-1.08.14-.26 0-.52-.03-.77-.07.52 1.63 2.04 2.82 3.83 2.85-1.4 1.1-3.17 1.76-5.1 1.76-.33 0-.66-.02-.98-.06 1.82 1.17 3.97 1.85 6.29 1.85 7.54 0 11.67-6.25 11.67-11.67 0-.18 0-.36-.01-.54.8-.58 1.49-1.3 2.04-2.12z"/>
                </svg>
              </a>
              <a href="#" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M10 1.8c2.67 0 2.987.01 4.042.059 2.71.123 3.975 1.409 4.099 4.099.048 1.054.057 1.37.057 4.042 0 2.67-.01 2.987-.057 4.042-.124 2.687-1.387 3.975-4.1 4.099-1.054.048-1.37.058-4.041.058-2.67 0-2.987-.01-4.04-.058-2.717-.124-3.977-1.416-4.1-4.1-.048-1.054-.058-1.37-.058-4.041 0-2.67.01-2.988.058-4.042.124-2.69 1.387-3.977 4.1-4.1 1.054-.047 1.37-.057 4.04-.057zM10 0C7.284 0 6.944.012 5.877.06 2.246.227.227 2.242.061 5.877.01 6.944 0 7.284 0 10s.012 3.057.06 4.123c.167 3.632 2.182 5.65 5.817 5.817 1.067.048 1.407.06 4.123.06s3.057-.012 4.123-.06c3.629-.167 5.652-2.182 5.816-5.817.05-1.066.061-1.407.061-4.123s-.012-3.056-.06-4.122C19.777 2.249 17.76.228 14.124.06 13.057.01 12.716 0 10 0zm0 4.865a5.135 5.135 0 100 10.27 5.135 5.135 0 000-10.27zm0 8.468a3.333 3.333 0 110-6.666 3.333 3.333 0 010 6.666zm5.338-9.87a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 